import React from 'react'

import { VmpNoAuthentication } from 'Vmp'
import { useAuth } from 'Auth/AuthContext'

type ContextProviderProps = {
  children: React.ReactNode
  disabled?: boolean
}
// 校验权限逻辑
const ValidateAuthentication: React.FC<ContextProviderProps> = props => {
  const auth = useAuth()
  return props.disabled ? <>{props.children}</> : !auth.jwt ? <VmpNoAuthentication /> : <>{props.children}</>
}

export default ValidateAuthentication
